import { useState } from 'preact/hooks'
import { exportSessionToCalendar } from '../utils/calendarUtils'

export function SessionCalendarButton({ session, isExpanded, onExportComplete }) {
  const [isExporting, setIsExporting] = useState(false)

  const handleExport = async (e) => {
    e.stopPropagation()
    
    if (isExporting) return

    setIsExporting(true)
    
    try {
      const result = await exportSessionToCalendar(session)
      onExportComplete?.(result)
    } catch (error) {
      console.error('Export failed:', error)
      onExportComplete?.({
        success: false,
        message: 'Failed to export session to calendar'
      })
    } finally {
      setIsExporting(false)
    }
  }

  // Consistent calendar icon SVG path
  const calendarIconPath = "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"

  if (isExpanded) {
    // Full button in expanded mode
    return (
      <button
        onClick={handleExport}
        disabled={isExporting}
        title="Export this session to your device calendar"
        className="flex items-center justify-center gap-1 
                   bg-editions-green/20 hover:bg-editions-green/30 
                   border border-editions-green/40 hover:border-editions-green/60
                   text-editions-green hover:text-white
                   rounded-lg font-medium transition-colors duration-200
                   disabled:opacity-50 disabled:cursor-not-allowed
                   w-[70px] h-[28px] text-xs flex-shrink-0"
      >
        {isExporting ? (
          <div className="w-3 h-3 border-2 border-editions-green/30 border-t-editions-green rounded-full animate-spin"></div>
        ) : (
          <>
            <svg className="w-3 h-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={calendarIconPath} />
            </svg>
            <span className="truncate">Add</span>
          </>
        )}
      </button>
    )
  }

  // Icon-only button in collapsed mode
  return (
    <button
      onClick={handleExport}
      disabled={isExporting}
      title="Add to Calendar - Export this session to your device calendar"
      className="rounded-lg transition-colors duration-200
                 text-editions-green hover:text-white
                 bg-editions-green/20 hover:bg-editions-green/30
                 border border-editions-green/40 hover:border-editions-green/60
                 disabled:opacity-50 disabled:cursor-not-allowed
                 w-[28px] h-[28px] flex items-center justify-center flex-shrink-0"
      aria-label="Add to Calendar"
    >
      {isExporting ? (
        <div className="w-3 h-3 border-2 border-editions-green/30 border-t-editions-green rounded-full animate-spin"></div>
      ) : (
        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={calendarIconPath} />
        </svg>
      )}
    </button>
  )
} 